import React, { useEffect } from 'react';
import ToggleSwitch from '../../../components/ToggleSwitch';
import RollOverConfig from '../../../models/RollOverConfig.js';
import { useParams } from 'react-router-dom';
import { getApi } from '../../../api/endpoints.js';
import { toast } from 'react-toastify';

const FormPartial = (props) => {
  const { rollOverConfig, setRollOverConfig } = props;
  const rollOverConfigObj = new RollOverConfig(rollOverConfig);
  const [getLeaseOfferDetailsApi] = getApi('showLeaseOffer');
  const params = useParams();

  useEffect(() => {
    rollOverConfigObj.configurable_id = params.id;
    getLeaseOfferDetails();
  }, [])

  const getLeaseOfferDetails = async () => {
    try{
      let response = await getLeaseOfferDetailsApi({id: params.id}).unwrap();
      rollOverConfigObj.swapCreditOnEmiPayment = response.data.lease_offer.swap_credit_on_emi_payment;
      setRollOverConfig(rollOverConfigObj.toStateJson());
    } catch(error) {
      toast.error(error.data?.message || 'Something went wrong !');
    }
  }

  const validateValue = (field) => {
    rollOverConfigObj.validate(field);
  }

  const changeValue = (field, value) => {
    if(field === 'fixed'){
      rollOverConfigObj['percent'] = '';
    } else if(field === 'percent'){
      rollOverConfigObj['fixed'] = '';
    }
    rollOverConfigObj[field] = value;
    validateValue(field);
    setRollOverConfig(rollOverConfigObj.toStateJson());
  }

  return <React.Fragment>
    <div className="mt-4">
      <div className="row">
        <div className="col-md-3 my-2">
          <label htmlFor="remaining_gte" className="form-label mb-1">Remaining Swaps</label>
          <input
            id="remaining_gte"
            value={rollOverConfigObj.remaining_gte}
            onChange={(e) => changeValue('remaining_gte', e.target.value)}
            type="number"
            className="form-control form-control-sm font-size-12"
            aria-describedby="montly_min_target_help"
            placeholder='Enter remaining swaps greater than'
          />
          <div id="montly_min_target_help" className="form-text text-danger mt-0">
            {rollOverConfigObj.errors.remaining_gte}
          </div>
        </div>
        <div className="col-md-3 my-2">
          <label htmlFor="percent" className="form-label mb-1">Percentage Swap Rollover %</label>
          <input
            id="percent"
            value={rollOverConfigObj.percent}
            onChange={(e) => changeValue('percent', e.target.value)}
            type="number"
            className="form-control form-control-sm font-size-12"
            aria-describedby="percent_help"
            placeholder='Enter percentage %'
          />
          <div id="percent_help" className="form-text text-danger mt-0">
            {rollOverConfigObj.errors.percent}
          </div>
        </div>
        <div className="col-md-3 my-2">
          <label htmlFor="fixed" className="form-label mb-1">Fixed Swap Rollover</label>
          <input
            id="fixed"
            value={rollOverConfigObj.fixed}
            onChange={(e) => changeValue('fixed', e.target.value)}
            type="number"
            className="form-control form-control-sm font-size-12"
            aria-describedby="fixed_help"
            placeholder='Enter fixed swap rollover'
          />
          <div id="fixed_help" className="form-text text-danger mt-0">
            {rollOverConfigObj.errors.fixed}
          </div>
        </div>
        <div className="col-md-3 my-2">
          <label htmlFor="is_active" className="form-label mb-1">Active Status</label>
          <ToggleSwitch
            id="is_active"
            label_left="Inactive"
            label_right ="Active"
            onChange={(e) => changeValue('is_active', !rollOverConfigObj.is_active)}
            checked={rollOverConfigObj.is_active}
          />
        </div>
      </div>
    </div>
  </ React.Fragment>
};

export default FormPartial;
